import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus/use-event-bus';
import { useEffect } from 'react';

export const EventBusCopyToClipboardListener = () => {
  const { listen, unlisten } = useEventBus();

  const hadnleCopyToClipboard = (event: any) => {
    const { text } = event.data as { text: string };

    navigator.clipboard.writeText(text);
  };

  useEffect(() => {
    const notificationListener = listen('copy-to-clipboard', hadnleCopyToClipboard);

    return () => unlisten('copy-to-clipboard', notificationListener);
  }, []);

  return null;
};
